import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/whatsapp-opt-ins")({
  component: lazyRouteComponent(() => import("./-pages/admin.whatsapp-opt-ins")),
  head: () => ({
    meta: [
      { title: "WhatsApp Opt-ins · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
